export default "__VITE_ASSET__B3qJ3DGj__"